import React from 'react'
import { StyledTXFailedLink, StyledTXFailedText, StyledTXSubText } from '../../style'
import Retry from 'assets/account-center/retry.svg?react'

type TransactionTextProps = {
  transactionFailed: boolean
  completedTransactions: number
  successfulTransactions: number
  totalTransactions: number
}

/**
 * Render the sub text for pending transactions. EG: 1 of 2 completed
 * @returns
 */
const TransactionText: React.FC<TransactionTextProps> = ({
  transactionFailed,
  totalTransactions,
  successfulTransactions,
}) => {
  // if a tx failed, and all Tx's have completed, show a retry link
  if (transactionFailed) {
    const retry = () => {
      console.log('TODO Retry logic')
    }
    return (
      <StyledTXFailedText>
        Transaction failed.{' '}
        <StyledTXFailedLink onClick={retry}>
          Please retry <Retry />
        </StyledTXFailedLink>
      </StyledTXFailedText>
    )
  }
  return (
    <StyledTXSubText>
      {successfulTransactions} of {totalTransactions} complete
    </StyledTXSubText>
  )
}
export default TransactionText
